/**
 * @file Openapi Schema
 * @version 0.1.0
 * @author Openapi Generator src_common/server/node_task/run_app/openapi/openapi.ts
 * @date 2026-03-02T16:47:38.375Z
 *
 * Details:
 * --- File generated by generator do not modify this file manually ---
 */

import { z } from 'zod';


// #/components/schemas/complianceReminderType
export const ComplianceReminderTypeZod = z.literal('ndl');
export type ComplianceReminderTypeType = z.TypeOf<typeof ComplianceReminderTypeZod>;


// #/components/schemas/complianceReminder
export const ComplianceReminderZod = z.object({
    accountId: z.number(),
    universe: z.string(),
    lastReminderDate: z.string(),
    reminderFrequency: z.number(),
    reminderType: ComplianceReminderTypeZod,
});
export type ComplianceReminderType = z.TypeOf<typeof ComplianceReminderZod>;


// #/components/schemas/complianceEmptyResponse
export const ComplianceEmptyResponseZod = z.unknown();
export type ComplianceEmptyResponseType = z.TypeOf<typeof ComplianceEmptyResponseZod>;


// #/components/schemas/complianceApiError
export const ComplianceApiErrorZod = z.object({
    code: z.number(),
    message: z.string(),
});
export type ComplianceApiErrorType = z.TypeOf<typeof ComplianceApiErrorZod>;


// #/components/schemas/complianceApiErrorResponse
export const ComplianceApiErrorResponseZod = z.object({
    error: ComplianceApiErrorZod,
});
export type ComplianceApiErrorResponseType = z.TypeOf<typeof ComplianceApiErrorResponseZod>;


// #/components/schemas/complianceExcludePayload
export const ComplianceExcludePayloadZod = z.object({
    durationMonths: z.number(),
});
export type ComplianceExcludePayloadType = z.TypeOf<typeof ComplianceExcludePayloadZod>;


// #/components/schemas/complianceExclusionInfoSimple
export const ComplianceExclusionInfoSimpleZod = z.object({
    starts: z.string(),
    reactivationAllowedAfter: z.string(),
});
export type ComplianceExclusionInfoSimpleType = z.TypeOf<typeof ComplianceExclusionInfoSimpleZod>;


// #/components/schemas/complianceCustomerStatusExclusionInfoSimple
export const ComplianceCustomerStatusExclusionInfoSimpleZod = z.object({
    accountId: z.number(),
    universe: z.string(),
    status: ComplianceExclusionInfoSimpleZod.optional(),
});
export type ComplianceCustomerStatusExclusionInfoSimpleType = z.TypeOf<typeof ComplianceCustomerStatusExclusionInfoSimpleZod>;


// #/components/schemas/complianceMatchedCustomersStatuses
export const ComplianceMatchedCustomersStatusesZod = z.object({
    createdExclusions: z.array(ComplianceCustomerStatusExclusionInfoSimpleZod),
    existingExclusions: z.array(ComplianceCustomerStatusExclusionInfoSimpleZod),
});
export type ComplianceMatchedCustomersStatusesType = z.TypeOf<typeof ComplianceMatchedCustomersStatusesZod>;


// #/components/schemas/complianceExcludedCustomers
export const ComplianceExcludedCustomersZod = z.object({
    customer: ComplianceCustomerStatusExclusionInfoSimpleZod,
    matched: ComplianceMatchedCustomersStatusesZod.optional(),
});
export type ComplianceExcludedCustomersType = z.TypeOf<typeof ComplianceExcludedCustomersZod>;

